// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"7e92f0f9","787":"39141403"}[chunkId] + ".chunk.js";
};